export default "__VITE_ASSET__DNFyWsz7__"